import { I18n } from '@calendly/i18n';
import classNames from 'classnames';
import { forwardRef } from 'react';
import { GeneralPopup } from './general_popup';
const descriptionCss = "dyhbkn5";
const Description = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(descriptionCss, props.className)} />;
});
export const AskInviteePopup = () => <GeneralPopup>
    <Description>
      {I18n.t('publisher.event_types.location.ask_invitee.type_any_response')}
    </Description>
  </GeneralPopup>;

require("./ask_invitee_popup.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./ask_invitee_popup.js");